import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { EssentialService } from "../../services/essential.service";
import { MenuService } from "../../services/menu.service";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
  // providers:[MenuService]
})
export class MenuComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;

  menuSiblings: any = [];
  allPages: any = [];
  parenMenu: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public menuService: MenuService) { }

  menuContentTheme = 'all';

  activeMenu: { parent: number };
  flatMenu: any[] = [];
  public searchText: any;
  public menus: any[] = [];
  public site: any;
  public user: any;
  public activeClass = false;

  ngOnInit() {

    if (this.data.authService && this.data.authService.isLoggedIn()) {
      this.user = this.data.authService.getLoggedUser();
    }

    this.settings.nav_background_color = this.settings.nav_background_color && this.settings.nav_background_color.charAt(0) === '#' ? this.settings.nav_background_color : this.getThemeColor(this.settings.nav_background_color);
    this.settings.nav_text_color = this.settings.nav_text_color && this.settings.nav_text_color.charAt(0) === '#' ? this.settings.nav_text_color : this.getThemeColor(this.settings.nav_text_color);
    this.settings.child_background_color = this.settings.child_background_color && this.settings.child_background_color.charAt(0) === '#' ? this.settings.child_background_color : this.getThemeColor(this.settings.child_background_color);
    this.settings.child_text_color = this.settings.child_text_color && this.settings.child_text_color.charAt(0) === '#' ? this.settings.child_text_color : this.getThemeColor(this.settings.child_text_color);

    this.menuContentTheme = this.settings.menuContentTheme || 'all';
    let slug = this.route.data['value'].data[0].slug;
    this.menuService.getMenu(this.settings.selectedCategory, this.data, slug);

    this.route.paramMap.subscribe(
      route => {
        slug = this.route.data['value'].data[0].slug;
        this.menuService.setActiveLink(this.settings.selectedCategory, slug);
      }
    )
  }

  public getThemeColor(color) {
    if (this.data && this.data.moduleService && this.data.moduleService.theme && this.data.moduleService.theme.colors) {
      return this.data.moduleService.theme.colors[color];
    } else {
      return 'initial';
    }
  }
 
  public navigateToCulture() {
    let link = ''
    //Customer portal
    let cpProductOutput: any = localStorage.getItem('cpProductOutput')
    if (this.route.data['value'].type == 1)
      link = this.getCultureLinkedPage(this.route.data['value'].id, this.settings.Culture);
    else
      link = this.getCultureLinkedBlog(this.route.data['value'].id, this.settings.Culture);

    if (link != '/' && this.data.moduleService.site.css) {
      this.setsiteCss(this.settings.Culture)
      this.data.moduleService.site.culture = this.settings.Culture;
      this.router.navigate([link]);
    } else {
      this.router.navigate([link]);
    }


    if (cpProductOutput) {
      cpProductOutput = JSON.parse(cpProductOutput)
      link = link + `/productpreview?step=${cpProductOutput.step}&userPropertiesId=${cpProductOutput.userPropertiesId}`
      localStorage.removeItem('cpProductOutput')  //cpProductOutput
      this.router.navigate([link]);
    }

  }

  public getCultureLinkedPage(id, culture) {
    const currentPage = this.data.dataChashingService.pages[id]
    if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
      let temp = JSON.parse(currentPage.addtionalMetaTags)
      for (let i = 0; i < temp.length; i++) {
        const element = temp[i];
        if (element.property == culture) {
          return this.setNewRoute(this.settings.prefix || '', element.content)
        }
      }
    }
    return this.setNewRoute(this.settings.prefix || '', '');
  }

  public getCultureLinkedBlog(id, culture) {
    const currentPage = this.data.dataChashingService.blogs[id]
    if (currentPage.addtionalMetaTags && currentPage.addtionalMetaTags != null) {
      let temp = JSON.parse(currentPage.addtionalMetaTags)
      for (let i = 0; i < temp.length; i++) {
        const element = temp[i];
        if (element.property == culture) {
          return this.setNewRoute(this.settings.prefix || '', element.content)
        }
      }
    }
    return '/';
  }

  public setNewRoute(prefix, newRoute) {
    this.router.config = [];
    this.data.moduleService.site.HostName = prefix.replace("/", '');
    this.data.routerService.getRoute();
    return '/' + prefix + newRoute
  }

  public setsiteCss(Culture) {
    let css = JSON.parse(this.data.moduleService.site.css);
    const head = document.getElementsByTagName('head')[0];
    if (css[Culture]) {
      const oldCss = document.getElementsByTagName('style');
      for (let index = 0; index < oldCss.length; index++) {
        const element = oldCss[index];
        if (element.id.indexOf(this.data.moduleService.site.culture + '-style') !== -1) {
          head.removeChild(element);
          index = index - 1;
        }
      }
      const culture_css = document.createElement('style');
      culture_css.type = 'text/css';
      culture_css.id = Culture + '-style';
      culture_css.appendChild(document.createTextNode(css[this.settings.Culture]));
      head.appendChild(culture_css);
    }
  }



}